/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const CATEGORY_AGENCY_FEES = 'agency_fees'
export const CATEGORY_CHARGE = 'charge'
export const CATEGORY_MANAGEMENT_FEES = 'management_fees'
export const CATEGORY_OTHER = 'other'
export const CATEGORY_REFUND = 'refund'
export const CATEGORY_RENT = 'rent'
export const CATEGORY_RENTAL_CHARGE = 'rental_charge'
export const CATEGORY_SECURITY_DEPOSIT = 'security_deposit'

export const TransactionCategories = [
  CATEGORY_AGENCY_FEES,
  CATEGORY_CHARGE,
  CATEGORY_MANAGEMENT_FEES,
  CATEGORY_OTHER,
  CATEGORY_REFUND,
  CATEGORY_RENT,
  CATEGORY_RENTAL_CHARGE,
  CATEGORY_SECURITY_DEPOSIT
]
